import { DatePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import dayjs from 'dayjs';
import { AddNewWorkingTimeDialogComponent } from 'src/app/components/main/employees/activity/working-times-history/add-new-working-time-dialog/add-new-working-time-dialog.component';
import { CompanyProductEpic } from 'src/app/models/company_product_epic.model';
import { User } from 'src/app/models/user.model';
import { ApiService } from 'src/app/services/api.service';
import { UserService } from 'src/app/services/user.service';
import { UtilsService } from 'src/app/services/utils.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix, MatHint } from '@angular/material/form-field';
import { MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatDateRangePicker } from '@angular/material/datepicker';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-company-product-report-dialog',
  templateUrl: './company-product-report-dialog.component.html',
  styleUrls: ['./company-product-report-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatDateRangeInput,
    MatStartDate,
    MatEndDate,
    MatDatepickerToggle,
    MatSuffix,
    MatDateRangePicker,
    MatHint,
    MatCheckbox,
    MatInput,
    MatSelectModule,
    MatDialogActions,
    MatButton,
    MatIcon,
  ],
})
export class CompanyProductReportDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<AddNewWorkingTimeDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private user = inject(UserService);
  protected fb = inject(UntypedFormBuilder);
  private api = inject(ApiService);
  protected utils = inject(UtilsService);

  form: UntypedFormGroup;
  users: User[] = [];
  epics: CompanyProductEpic[] = [];

  constructor() {
    this.form = this.fb.group({
      usersSelected: [''],
      from: [dayjs().subtract(1, 'month').startOf('month').toDate()],
      to: [dayjs().subtract(1, 'month').endOf('month').toDate()],
      company_product_id: [this.data.company_product.id],
      use_time_invested: [false],
      multiplier: [null],
      company_product_epic_ids: [[] as (number | null)[]],
    });
  }

  ngOnInit(): void {
    this.fetchWorkers();
    this.fetchEpics();
  }

  fetchEpics() {
    this.api.getCompanyProductEpicsByCompanyProduct(String(this.data.company_product.id)).subscribe(epics => {
      this.epics = epics;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  fetchWorkers() {
    const params: any = { role_id: 1 };
    this.api.getUsers(params).subscribe(users => {
      this.users = users.data;
    });
  }

  onSubmitPdf() {
    let datePipe = new DatePipe('es-ES');
    const epicIds: (number | null)[] = this.form.value['company_product_epic_ids'] ?? [];
    this.api
      .getWorkingTimeReportBusinessPartner(
        this.form.value['company_product_id'],
        datePipe.transform(this.form.value.from, 'yyyy-MM-dd') as string,
        datePipe.transform(this.form.value.to, 'yyyy-MM-dd') as string,
        this.form.value.multiplier,
        this.form.value.use_time_invested,
        'pdf',
        Array.isArray(epicIds) ? epicIds : []
      )
      .subscribe(data => {
        this.utils.downloadPdfFromBlobResponse(data);
      });
  }

  onSubmitCsv() {
    let datePipe = new DatePipe('es-ES');
    const epicIds: (number | null)[] = this.form.value['company_product_epic_ids'] ?? [];
    this.api
      .getWorkingTimeReportBusinessPartner(
        this.form.value['company_product_id'],
        datePipe.transform(this.form.value.from, 'yyyy-MM-dd') as string,
        datePipe.transform(this.form.value.to, 'yyyy-MM-dd') as string,
        this.form.value.multiplier,
        this.form.value.use_time_invested,
        'csv',
        Array.isArray(epicIds) ? epicIds : []
      )
      .subscribe(data => {
        this.utils.downloadCsvFromBlobResponse(data);
      });
  }
}
